// extracted by mini-css-extract-plugin
module.exports = {"bed":"bed_option_bed__3kr6M","roomTitle":"bed_option_roomTitle__1eKRX","bedIcon":"bed_option_bedIcon__2CXCw"};